export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  // Homologacao: envia a mensagem como se fosse o LEAD (message_type incoming),
  // pra testar a DH internamente. So disponivel em inbox de homologacao.
  HOMOLOGACAO: 'HOMOLOGACAO',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
